const allowedButtonColors = [
  'primary',
  'secondary',
  'gray',
  'enhanced',
  'danger',
  'white',
  'facebook'
];

const allowedActionElementStyles = [
  'normal',
  'link',
  'linkShy',
  'linkDark',
  'linkCover',
  'button',
  'buttonLink',
  'buttonWrap',
  'buttonOutline'
];

export {
  allowedButtonColors,
  allowedActionElementStyles
};